import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import QRCode from "react-qr-code";

// bootstrap
import { Row, Col } from 'react-bootstrap';

// custom components
import { Card } from '_atoms';

// tremor
import { Flex, Text, List, ListItem, Subtitle } from "@tremor/react";


//redux 
import { useSelector, useDispatch } from "react-redux";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { getAndroidAppVersion, selectAndroidAppVersion } from '_redux/slices/timeline/employees';
import { selectPreBoard } from '_redux/slices/timeline/timeline-control';

// constants 
import { SaudiDomesticAirports } from "_utils/timeline-constants";
//custom-components
import RowsPerPage from './rows-per-page';
import TimelineScrollTimer from './timeline-scroll-timer';
import * as TaskColors from "../utils/colors";
import AutoAcceptUnplannedTask from './auto-accept-task';
import PreBoardSwitch from './pre-board-switch';
import AutoCheckInLocation from './auto-checkin-location';
import AllFlightsSwitch from './all-flights-switch';
import RampBookingsSwitch from './ramp-bookings-switch';
import ExpandAllFlightsSwitch from './expand-all-flights-switch';
import ThirtyMinLayoutSwitch from './thirtyMin-layout-switch';
import DarkModeToggle from './dark-mode-toggle'
import LayoutSwitch from './layout-switch';
// icons
import { IoChevronBackCircleSharp } from "react-icons/io5";

import { Colors } from "_styles";

const ControlPanel = () => {

    // nav
    const history = useHistory();

    //#region redux
    const dispatch = useDispatch()
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user
    const preBoard = useSelector(selectPreBoard);                                         // status of auto accept unplaned task switch
    const androidAppVersion = useSelector(selectAndroidAppVersion);                       // employee Android app version and link

    //#endregion

    //#region useEffect
    // get employee Android App version 
    useEffect(() => {
        dispatch(getAndroidAppVersion(dbUser.details.authority))
    }, [])
    //#endregion

    //#region components 
    const Color = (props) => {
        return (
            <div style={{
                width: 15, height: 15, borderRadius: 25, backgroundColor: props.color, marginTop: 2.5, marginLeft: 2.5
            }} />
        )
    }
    const ListRow = (props) => {
        return (
            <ListItem>
                <Flex>
                    <Text truncate={true}> {props.string} </Text>
                    <div style={{ display: 'flex' }}>
                        <Color color={props.color} />
                    </div>
                </Flex>
            </ListItem>
        )
    }

    //#endregion

    return (

        <>
            {/* go back to timeline icon*/}
            <IoChevronBackCircleSharp
                size={35}
                onClick={() => history.push('timeline-view')}
                color={Colors.PRM_LIGHT_BLUE} cursor="pointer"
                style={{}}
            />

            <Row className="g-4">


                {/*auto accept unplanned task */}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <AutoAcceptUnplannedTask />
                </Col >

                {/* employees Rows per page*/}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <RowsPerPage />
                </Col>

                {/*Pre board switch */}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <PreBoardSwitch />
                </Col>

                {/*Ramp Bookings switch */}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <RampBookingsSwitch />
                </Col>

                {/*display all flights switch */}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <AllFlightsSwitch />
                </Col>

                {/*expand all flights switch */}
                <Col xs={12} md={4} lg={6} className="d-flex">
                    <ExpandAllFlightsSwitch />
                </Col>

                <Col xs={12} md={4} lg={6} className="d-flex">
                    <TimelineScrollTimer />
                </Col>

                <Col xs={12} md={4} lg={6} className="d-flex">
                    <AutoCheckInLocation />
                </Col>

                {["DUB", "ORK"].includes(dbUser.details.authority) && <Col xs={12} md={4} lg={6}>
                    <ThirtyMinLayoutSwitch />
                </Col>}
            </Row>

            {/* color legend */}
            <Row className='mt-3'>
                <Col xs={12} lg={6} md={6} className="d-flex">
                    <Card>
                        <Subtitle>{'Task Legend'}</Subtitle>
                        <List>
                            {SaudiDomesticAirports.includes(dbUser.details.authority) ?
                                <>
                                    {preBoard ?
                                        <>
                                            <ListRow string={'Departures'} colorString={'Pink'} color={TaskColors.departures} />
                                            <ListRow string={'Estimated Departures'} colorString={'Blue'} color={TaskColors.internationalDepartures} />
                                        </>
                                        :
                                        <>
                                            <ListRow string={'International Departures'} colorString={'Blue'} color={TaskColors.internationalDepartures} />
                                            <ListRow string={'Domestic Departures'} colorString={'Light Blue'} color={TaskColors.domesticDepartures} />
                                        </>

                                    }


                                    <ListRow string={'International Arrivals'} colorString={'Green'} color={TaskColors.internationalArrivals} />
                                    <ListRow string={'Domestic Arrivals'} colorString={'Light Green'} color={TaskColors.domesticArrivals} />
                                </> :
                                <>
                                    <ListRow string={'Departures'} colorString={'Blue'} color={preBoard ? TaskColors.departures : TaskColors.internationalDepartures} />
                                    {preBoard && <ListRow string={'Estimated Departures'} colorString={'Blue'} color={TaskColors.internationalDepartures} />}
                                    <ListRow string={'Arrivals'} colorString={'Green'} color={TaskColors.internationalArrivals} />
                                </>
                            }


                            <ListRow string={'Transit Passengers'} colorString={'Purple'} color={TaskColors.transitBookings} />

                            <ListRow string={'Completed Tasks'} colorString={'Green'} color={TaskColors.completedTasks} />
                            <ListRow string={'Active Tasks'} colorString={'Orange'} color={TaskColors.activeTasks} />
                            <ListRow string={'Rejected Tasks'} colorString={'Red'} color={TaskColors.rejectedTasks} />

                        </List>
                    </Card>
                </Col>
                {androidAppVersion?.version && androidAppVersion?.url &&
                    <Col xs={12} lg={6} md={6} className="d-flex">
                        <Card>
                            <Subtitle>{'Scan QR code to get the mobile application'}</Subtitle>
                            <Subtitle>{`Version Number: ${androidAppVersion?.version}`}</Subtitle>
                            <QRCode
                                size={200}
                                style={{ height: "228px", maxWidth: "100%", width: "100%", marginTop: "10px" }}
                                value={androidAppVersion?.url}
                            />
                        </Card>
                    </Col>
                }
            </Row>

        </>
    );
};

export default ControlPanel;